<section class="mx-3">
<div class="hdrpadding d-flex justify-content-between align-items-center" *ngIf="!showForm">
  <div *ngIf="!showForm">
    <h2 class="m-0" translate>E-Content - Courses</h2>
  </div>
  <button mat-raised-button color="primary" (click)="createEcontentData()">
    <i class="fa-solid fa-plus"></i>
    <span translate>Add E-Content</span>
  </button>
</div>

<div class="hdrpadding d-flex  align-items-center" *ngIf="showForm">
  <div>
    <button class="back_icon me-2" (click)="navigateToBackPage()">
      <i class="fa-solid fa-arrow-left"></i>
    </button>
  </div>
  <div style="margin: 0% 1%;">
    <h2 class="m-0" translate>E-Content</h2>
  </div>
</div>
<app-toast></app-toast>
<div class="table-container mt-2 table" *ngIf="!showForm">
  <!-- Content Section -->
  <!-- <div class="mt-2 h-100" > -->
    <!-- Table Section -->
    <table *ngIf="
        dataSource && dataSource.data && dataSource.data.length > 0;
        else emptyState
      " mat-table [dataSource]="dataSource" class="mat-elevation-z1">
      <!-- Course Name Column -->
      <ng-container matColumnDef="slno">
        <th mat-header-cell *matHeaderCellDef translate>Sl. no</th>
        <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
      </ng-container>
      <!-- Course Name Column -->
      <ng-container matColumnDef="courses">
        <th mat-header-cell *matHeaderCellDef translate>Courses</th>
        <td mat-cell *matCellDef="let element">{{ element.course_name }}</td>
      </ng-container>

      <!-- Last Update Column -->
      <ng-container matColumnDef="last_update">
        <th mat-header-cell *matHeaderCellDef translate>Last Update</th>
        <td mat-cell *matCellDef="let element">
          {{ element.updated_at | date : "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <div style="float: right;padding: 0% 11%;" translate>Actions</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div style="flex-direction: row;display: flex;justify-content: flex-end">
            <button matButton class="viewBtn" (click)="viewESemisterData(element.course_id)" style="margin-top:2%;">
              <span translate>View</span>
            </button>
            <div class="action_button" [matMenuTriggerFor]="menu" aria-label="Actions">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
          <mat-menu #menu="matMenu">
            <!-- <button
              mat-menu-item
              (click)="viewESemisterData(element.course_id)"
            >
              <mat-icon>visibility</mat-icon>
              <span>View</span>
            </button> -->
            <button mat-menu-item>
              <mat-icon>edit</mat-icon>
              <span translate>Edit</span>
            </button>
            <button mat-menu-item (click)="deleteEContentCoursesData(element.course_id)">
              <mat-icon>delete</mat-icon>
              <span translate>Delete</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- Empty State Template -->
    <ng-template #emptyState>
      <mat-card class="empty-state-card text-center py-5">
        <mat-card-content>
          <!-- <p>Please add E-content courses to get started.</p> -->
          <span style="margin: -8% 0%;" translate>Click on Add Content button</span>
          <span translate>to start Adding.</span>
          <button mat-raised-button color="primary" (click)="createEcontentData()">
            <i class="fa-solid fa-plus"></i>
            <span translate>Add E-Content</span>
          </button>
        </mat-card-content>
      </mat-card>
    </ng-template>
  </div>

  <!-- Form Section -->
  <app-e-content-form *ngIf="showForm" [questions]="questions" [form]="form" (submitForm)="onFormSubmit($event)"
    (cancel)="navigateToBackPage()"></app-e-content-form>
<!-- </div> -->
</section>